/**
 * The restaurant's working day, as this device sees it.
 *
 * A shift that runs past midnight belongs to the day it started on, so the day turns
 * over at 3am rather than midnight (owner decision 2026-09-17). The terminals run on
 * restaurant time, so the device clock is used; the server independently files each
 * entry it receives against the restaurant timezone, so a phone with a wrong timezone
 * only affects how its own logs are grouped on screen, never where they are stored.
 */
export const BUSINESS_DAY_START_HOUR = 3;

const pad = value => String(value).padStart(2, "0");

export function businessDateFor(moment = new Date(), startHour = BUSINESS_DAY_START_HOUR) {
  const shifted = new Date(moment.getTime() - startHour * 60 * 60 * 1000);
  return `${shifted.getFullYear()}-${pad(shifted.getMonth() + 1)}-${pad(shifted.getDate())}`;
}
